import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import useModalRetornarVeiculo, { LOAD_MESSAGE } from './ModalRetornarVeiculoHook'
import { Btn, CustomCalendar, CustomModal } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

function ModalRetornarVeiculo({ show, onModalClose, onModalSave, dispatch, fleet }) {
  const { state, localDispatch } = useModalRetornarVeiculo()

  useEffect(() => {
    if (show) {
      localDispatch.onInit(fleet)
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE_UPDATE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveUpdateDelivery(state.fleet, state.returned_time)
        break
      case LOAD_MESSAGE.LOADING_EDIT:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        onModalSave()
        localDispatch.resetState()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetError()
      onModalClose()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Retorno de Veículo"
      isVisible={show}
      onClose={() => {
        localDispatch.resetState()
        onModalClose()
      }}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <CustomCalendar
            marginTop={9}
            label="Data de Retorno:"
            value={state.returned_time}
            onChange={value => localDispatch.onInputChange('returned_time', value)}
            showTime
            hourFormat="24"
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClicked()}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalRetornarVeiculo)
